import { Loading } from "components/assets/Icons";
import styles from "./Loader.module.scss";

const Loader = () => {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.spinner}>
        <Loading />
      </div>
      <p className={styles.loadingText}>Loading...</p>
    </div>
  );
};

export default Loader; 